import { call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../../helpers/request';
import { notificationsActions } from '../../Notifications/slice';
import { knowledgeBaseActions as actions } from '.';
import { API, SIMULATED_SYNC_DELAY_MS } from './constants';
import type { KnowledgeBaseAction, Response } from './types';



async function sleep(ms: number) {
  await new Promise((resolve) => window.setTimeout(resolve, ms));
}

export function* fetchKnowledgeBaseGenerator({ payload }: KnowledgeBaseAction) {
  try {
    const response: Response = yield call(request, API.GET_KNOWLEDGE_BASE_ROWS, payload, true);

    if (response?.success) {
      const data = response.data;
      const items = data?.items ? data.items : [];
      const total = data?.total ? data.total : items.length;

      yield put(actions.fetchKnowledgeBaseSucceeded({ items, total }));
    } else {
      yield put(actions.fetchKnowledgeBaseFailed({ message: response?.message || 'Failed to load knowledge base items.' }));
    }
  } catch (err: any) {
    yield put(actions.fetchKnowledgeBaseFailed({ message: err?.message || 'Failed to load knowledge base items.' }));
  }
}


export function* syncBlogsGenerator({ payload }: KnowledgeBaseAction) {
  try {
    const response: Response = yield call(request, API.SYNC_KNOWLEDGE_BASE, payload, true);

    if (response?.success) {
      const data = response.data;
      yield put(actions.syncBlogsFinished());

      yield put(notificationsActions.setNotification({ message: `${data.message}`, type: 'success' }));
    } else {
      yield put(actions.syncBlogsFinished());
      yield put(notificationsActions.setNotification({ message: response?.message || 'Failed to sync knowledge base.', type: 'error' }));
    }
  } catch (err: any) {
    yield put(actions.syncBlogsFinished());
    yield put(notificationsActions.setNotification({ message: err?.message || 'Failed to sync knowledge base.', type: 'error' }));
  }
}

export function* customSyncGenerator({ payload }: KnowledgeBaseAction) {
  try {
    yield call(sleep, SIMULATED_SYNC_DELAY_MS);
    yield put(actions.customSyncFinished());
    yield put(
      notificationsActions.setNotification({
        message: `Custom sync triggered${payload?.productId ? ` for ${payload.productId}` : ''}.`,
        type: 'success',
      }),
    );
  } catch (err: any) {
    yield put(actions.customSyncFinished());
    yield put(
      notificationsActions.setNotification({
        message: err?.message || 'Failed to trigger custom sync.',
        type: 'error',
      }),
    );
  }
}

export function* knowledgeBaseSaga() {
  yield takeLatest(actions.fetchKnowledgeBaseRequested.type, fetchKnowledgeBaseGenerator);
  yield takeLatest(actions.syncBlogsRequested.type, syncBlogsGenerator);
  yield takeLatest(actions.customSyncRequested.type, customSyncGenerator);
}

export default knowledgeBaseSaga;
